import React, { FC } from "react";
import { faWarning } from "@fortawesome/pro-regular-svg-icons/faWarning";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Warning: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faWarning} {...props} />
);
